import { css } from 'aphrodite';
import { Button } from '../../../components-v2/Button';
import { THEME } from '../../../components-v2/Theme/theme';
import { CloseButton } from '../../CloseButton';
import { Modal } from '../../Modal';
import { WarningIcon } from '../../svgs/icons/WarningIcon';
import { styleSheet } from './styles';

type Props = {
	isOpen: boolean;
	onRequestClose: () => void;
};

export const NotifyAttachmentsUnionModal = ({ isOpen, onRequestClose }: Props) => {
	return (
		<Modal isOpen={isOpen} onRequestClose={onRequestClose} className={css(styleSheet.attachmentUnionModal)}>
			<div className={css(styleSheet.attachmentUnionModalContentContainer)}>
				<div className={css(styleSheet.attachmentUnionModalCloseButton)}>
					<CloseButton
						styles={[styleSheet.attachmentUnionModalCloseButtonIcon]}
						onClick={() => onRequestClose()}
						fillColor={THEME.colors.icon.gray}
						size={12}
					/>
				</div>

				<WarningIcon />
				<h1 className={css(styleSheet.attachmentUnionModalTitle)}>Attachments Retained</h1>
				<p className={css(styleSheet.attachmentUnionModalDescription)}>
					You&apos;re about to apply a new template. Any existing attachments will be kept unless you remove them
					manually.
				</p>
				<div>
					<Button onClick={() => onRequestClose()} size='lg' styles={[styleSheet.attachmentUnionModalContinueButton]}>
						Continue
					</Button>
				</div>
			</div>
		</Modal>
	);
};
